const langAuthPasswordForgot = {
	title_forgot_password: {
		tag: 'auth.forgot_password.title_forgot_password',
		fr: 'Réinitialisez votre mot de passe',
		en: 'Reinit your password',
	},
	label_email: {
		tag: 'auth.forgot_password.label_email',
		fr: 'Saisissez votre adresse e-mail',
		en: 'Enter your email address',
	},
	field_error_email_required: {
		tag: 'auth.forgot_password.field_error_email_required',
		fr: "L'adresse e-mail est requise",
		en: 'E-mail is required',
	},
	field_error_email_invalid: {
		tag: 'auth.forgot_password.field_error_email_invalid',
		fr: "L'adresse e-mail est invalide",
		en: 'The e-mail address is invalid',
	},
	btn_reinit_password: {
		tag: 'auth.forgot_password.btn_reinit_password',
		fr: 'Réinitialiser mon mot de passe',
		en: 'Reinit my password',
	},
	text_presentation: {
		tag: 'auth.forgot_password.text_presentation',
		fr: 'Veuillez saisir votre adresse e-mail afin de réinitialiser votre mot de passe. Vous recevrez un lien de réinitialisation sur cette adresse.',
		en: 'Please enter your email address to reset your password. You will receive a reset link at this address.',
	},
	text_success: {
		tag: 'auth.forgot_password.text_success',
		fr: "Un courriel a été envoyé à votre adresse électronique avec les instructions pour réinitialiser votre mot de passe. Si vous ne voyez pas l'email dans quelques minutes, veuillez vérifier vos dossiers de courrier indésirable ou de spam",
		en: 'An email has been sent to your email with instructions on resetting your password. If you do not see the email in a few minutes, please check your junk mail or spam folders',
	},
	text_error: {
		tag: 'auth.forgot_password.text_error',
		fr: 'Un problème est survenu, veuillez contacter votre administrateur.',
		en: 'Something went wrong, please contact your Administrator.',
	},
};

export default langAuthPasswordForgot;
